import { useEffect } from 'react';

type ReadFormat = 'array-buffer' | 'binary-string' | 'data-url' | 'text';

const resolveReadMethod = (
  format?: ReadFormat,
):
  | 'readAsArrayBuffer'
  | 'readAsBinaryString'
  | 'readAsDataURL'
  | 'readAsText' => {
  switch (format) {
    case 'array-buffer':
      return 'readAsArrayBuffer';
    case 'binary-string':
      return 'readAsBinaryString';
    case 'data-url':
      return 'readAsDataURL';
    case 'text':
    default:
      return 'readAsText';
  }
};

export function useFileReader(
  file?: File | null | undefined,
  format?: 'array-buffer',
  callback?: (error: DOMException | null, result: ArrayBuffer) => void,
): void;

export function useFileReader(
  file?: File | null | undefined,
  format?: 'binary-string' | 'data-url' | 'text',
  callback?: (error: DOMException | null, result: string) => void,
): void;

export function useFileReader(
  file?: File | null | undefined,
  format?: ReadFormat,
  callback?: (error: DOMException | null, result: any) => void,
): void {
  useEffect((): (() => void) => {
    let reader: FileReader;
    if (file && callback) {
      reader = new FileReader();
      const readMethod = resolveReadMethod(format);
      reader.onload = (): void => callback(null, reader.result);
      reader.onerror = (): void => callback(reader.error, null);
      reader[readMethod](file);
    }
    return (): void => {
      if (reader) {
        reader.abort();
      }
    };
  }, [file, format, callback]);
}
